import { getTranslate } from '@/utils/api-interceptors'

interface PromotionType {
  promotionData: {
    order: number
    value: {
      vi: string
      en: string
    }
  }[]
}

export const Promotion = ({ promotionData }: PromotionType) => {
  return (
    <>
      {promotionData && promotionData.length > 0 && (
        <div className='entry-promotion border-b-8 border-gray-200'>
          <div className='promo-main w-full px-3 py-5'>
            <ul className='flex flex-wrap'>
              {promotionData
                .sort(function (a, b) {
                  return a.order - b.order
                })
                .map((promo, index) => {
                  return (
                    <li
                      className='mb-2 flex w-full text-base last:mb-0'
                      key={index}
                    >
                      <span className='mt-[2px] flex h-4 max-w-[16px] flex-[16px] items-center justify-center rounded-full font-bold bg-primary-basetext-xs text-white-400'>
                        {index + 1}
                      </span>
                      <span className='ml-3 flex-2 leading-5 text-dark-400 text-sm'>
                        {getTranslate(promo.value)}
                      </span>
                    </li>
                  )
                })}
            </ul>
          </div>
        </div>
      )}
    </>
  )
}

export default Promotion
